import { useEffect } from 'react'

import { WatchQueryFetchPolicy } from '@apollo/client'

import { isServer } from 'src/libs/helper'
import { ProjectSummaryTranslator } from 'src/translators'
import { useGetProjectSummaryQuery } from 'src/types/generated'

type Options = {
  refetchOnWindowFocus?: boolean
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useGetProjectSummary = (options?: Options) => {
  const { loading, data, error, refetch } = useGetProjectSummaryQuery({
    fetchPolicy: options?.fetchPolicy,
  })

  useEffect(() => {
    if (isServer || !options?.refetchOnWindowFocus) {
      return
    }

    // windowがフォーカスされたときに refetch を実行
    const handleFocus = () => {
      refetch()
    }

    window.addEventListener('focus', handleFocus)
    return () => window.removeEventListener('focus', handleFocus)
  }, [options?.refetchOnWindowFocus, refetch])

  return {
    loading,
    projectCountHistories:
      data && data.projectSummary ? ProjectSummaryTranslator.toEntities(data.projectSummary) : [],
    error,
    refetch,
  }
}
